<template>
  <div class="app">
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
  },
  setup() {
    const store = useStore();
    
    onMounted(() => {
      store.dispatch('theme/initializeTheme');
      store.dispatch('auth/restoreSession');
      store.dispatch('cart/initializeCart'); // Cart initializatsiya
    });
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: #ffffff;
  color: #2c3e50;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.dark-mode body {
  background: #0f172a;
  color: #f1f5f9;
}

.app {
  min-height: 100vh;
}

.main-content {
  padding-top: 64px;
  min-height: calc(100vh - 64px);
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 60px;
  }
}
</style>